import { IUploaderColumnConfig } from "../../../../../../components/ui/UploaderFlow/types/types";
import { CommonColDefFieldNamesEnum, StakeholderColDefFieldNamesEnum } from "../../../enums/AgGridColDefFieldNameEnum";

export const STAKEHOLDER_GRID_UPLOADER_CONFIG: IUploaderColumnConfig[] = [
  {
    key: StakeholderColDefFieldNamesEnum.FirstName,
    name: "First Name",
    type: "text",
    placeholder: "Enter first name",
    required: true
  },
  {
    key: StakeholderColDefFieldNamesEnum.LastName,
    name: "Last Name",
    type: "text",
    placeholder: "Enter last name",
    required: true
  },
  {
    key: StakeholderColDefFieldNamesEnum.Email,
    name: "Email",
    type: "email",
    placeholder: "Enter email address",
    required: true
  },
  {
    key: StakeholderColDefFieldNamesEnum.BusinessArea,
    name: "Business Area",
    type: "entityRelation",
    required: false
  },
  {
    key: StakeholderColDefFieldNamesEnum.Role,
    name: "Role",
    type: "entityRelation",
    required: false
  },
  {
    key: CommonColDefFieldNamesEnum.Owner,
    name: "Owner",
    type: "entityRelation",
    required: true
  }
];
